import { useEffect } from "react"
import { useNavigate } from "./router"

const HOME_BY_ROLE = {
  admin: "/admin/dashboard",
  coach: "/coach/dashboard",
  swimmer: "/swimmer/dashboard",
  club: "/club-admin/dashboard",
}

// Wrap any route that should only render for specific roles. Without this,
// the router renders the requested page regardless of who's logged in (or
// whether anyone is) — the backend rejects the API calls, but the page
// shell itself still shows. `role` is a single role string or an array.
export default function RequireRole({ role, children }) {
  const navigate = useNavigate()
  const token = localStorage.getItem("token")
  const userRole = localStorage.getItem("role")
  const allowed = Boolean(token) && (Array.isArray(role) ? role.includes(userRole) : userRole === role)

  useEffect(() => {
    if (!token) {
      navigate("/login")
    } else if (!allowed) {
      // Not their role — send them straight to their own dashboard, not
      // through /dashboard's own async re-check (avoids a double redirect).
      navigate(HOME_BY_ROLE[userRole] || "/login")
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return allowed ? children : null
}
